









































import Vue from 'vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';
import Input from '../common/Input/Input.vue';
export default Vue.extend({
  props: ['getResult', 'fileName'],
  components: {
    NotificationText,
    CheckBox,
    Input,
  },
  data(): {
    separatorList: string[];
    error: boolean;
    slashSelected: boolean;
    hyphenSelected: boolean;
    underbarSelected: boolean;
    dotSelected: boolean;
    commaSelected: boolean;
    personalSeparatorSelected: boolean;
    personalSeparator: string;
  } {
    return {
      separatorList: [],
      error: false,
      slashSelected: false,
      hyphenSelected: false,
      underbarSelected: false,
      dotSelected: false,
      commaSelected: false,
      personalSeparatorSelected: false,
      personalSeparator: ``,
    };
  },
  methods: {
    onClickButton() {
      if (
        !this.slashSelected &&
        !this.hyphenSelected &&
        !this.underbarSelected &&
        !this.dotSelected &&
        !this.commaSelected &&
        !this.personalSeparatorSelected
      ) {
        this.error = true;
      }

      let payload = {
        ok: !this.error,
        exampleData: [''],
        parsing_rule: {
          seperator: [''],
          properties: [''],
        },
      };

      payload.parsing_rule.seperator = this.separatorList;
      if (this.personalSeparator !== '') {
        payload.parsing_rule.seperator.push(this.personalSeparator);
      }

      let exampleData: string[] = [];

      (this.$refs.word as HTMLSpanElement[]).forEach((wordElement) => {
        if (
          wordElement.classList.contains('box') &&
          wordElement.classList.contains('selected')
        ) {
          exampleData.push(wordElement.innerText);
        } else if (wordElement.classList.contains('box')) {
          exampleData.push('');
        }
      });

      payload.exampleData = exampleData;
      payload['parsing_rule'].properties = exampleData.map(() => '');

      this.$emit('pushResult', payload);
    },
    changeSeparatorList(flag: boolean, separator: string) {
      if (flag) {
        this.separatorList.push(separator);
      } else {
        this.separatorList = this.separatorList.filter((el: string) => {
          return el !== separator;
        });
      }
    },
    onClickWord(e: Event) {
      if ((e.target as HTMLSpanElement).classList.contains('selected')) {
        (e.target as HTMLSpanElement).classList.remove('selected');
      } else {
        (e.target as HTMLSpanElement).classList.add('selected');
      }
    },
  },
  computed: {
    parsedFileName: function (): string[] {
      let parsedFileName = [this.fileName];
      this.separatorList.forEach((separator: string) => {
        let tmpParsedFileName: string[] = [];
        parsedFileName.forEach((word) => {
          tmpParsedFileName = tmpParsedFileName.concat(
            word.split(new RegExp(`(\\${separator})`, `g`)),
          );
        });
        parsedFileName = tmpParsedFileName;
      });

      if (this.personalSeparator !== '') {
        let tmpParsedFileName: string[] = [];
        parsedFileName.forEach((word) => {
          tmpParsedFileName = tmpParsedFileName.concat(
            word.split(new RegExp(`(${this.personalSeparator})`, `g`)),
          );
        });
        parsedFileName = tmpParsedFileName;
      }

      return parsedFileName;
    },
  },
  watch: {
    slashSelected: function (slashSelected) {
      this.changeSeparatorList(slashSelected, '/');
    },
    hyphenSelected: function (hyphenSelected) {
      this.changeSeparatorList(hyphenSelected, '-');
    },
    underbarSelected: function (underbarSelected) {
      this.changeSeparatorList(underbarSelected, '_');
    },
    dotSelected: function (dotSelected) {
      this.changeSeparatorList(dotSelected, '.');
    },
    commaSelected: function (commaSelected) {
      this.changeSeparatorList(commaSelected, ',');
    },
    personalSeparatorSelected: function (personalSeparatorSelected) {
      if (!personalSeparatorSelected) {
        this.personalSeparator = '';
      }
    },
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickButton();
      }
    },
  },
});
